import {
  Accordion,
  AccordionDetails,
  Grid,
  Typography,
  useEventCallback,
  SelectChangeEvent,
  Divider,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikTouched } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { IdentityCardVM } from 'shell/view-models/search-anpr';
import PmiTextField from 'shell/components/shared/text-field';
import ConsulateList from 'shell/components/shared/consulate-list';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { FiltersPersonSearch } from 'shell/constants/filters-person-search';

interface FiltersIdentityCardProps {
  open?: boolean;
  onOpenAccordion: (value: FiltersPersonSearch) => void;
  values?: IdentityCardVM;
  onChange: (key: keyof IdentityCardVM, value: IdentityCardVM[keyof IdentityCardVM]) => void;
  errors?: FormikErrors<IdentityCardVM>;
  touched?: FormikTouched<IdentityCardVM>;
}

const FiltersIdentityCard = ({
  values,
  onChange,
  open,
  onOpenAccordion,
  errors,
  touched,
}: FiltersIdentityCardProps): React.ReactElement => {
  const onChangeMunicipality = useEventCallback((municipality: MunicipalityAnprVM | null) =>
    onChange('municipality', municipality)
  );

  const onChangeConsulate = useEventCallback((event: SelectChangeEvent<string>) =>
    onChange('consulate', event.target.value)
  );
  return (
    <Accordion
      expanded={open}
      onChange={() => {
        onOpenAccordion(FiltersPersonSearch.IdentityCard);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-filters-residence-permit-content"
        id="panel-person-filters-residence-permit-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>{"Ricerca per Carta d'identità"}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Numero carta"
                label="Numero Carta *"
                id="number"
                name="number"
                fullWidth
                type="text"
                inputProps={{
                  maxLength: '20',
                }}
                variant="outlined"
                value={values?.number}
                onChange={(event) => onChange('number', event.target.value?.toUpperCase())}
                error={touched?.number && Boolean(errors?.number)}
                helperText={errors?.number}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <MunicipalityList
              value={values?.municipality || null}
              onChange={onChangeMunicipality}
              label="Comune"
              id="municipalityIdentityCard"
              error={touched?.municipality && Boolean(errors?.municipality)}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <PmiTextField
              aria-label="Provincia"
              label="Provincia"
              id="provinceIdentityCard"
              name="provinceIdentityCard"
              fullWidth
              type="text"
              disabled
              variant="outlined"
              value={values?.municipality?.province || ''}
              onChange={(event) => onChange('province', event.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={4}>
            <ConsulateList
              value={values?.consulate || ''}
              onChange={onChangeConsulate}
              label="Consolato rilascio"
              id="consulateIdentityCard"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersIdentityCard.displayName = 'Filters Person Identity Card component';

export default FiltersIdentityCard;
